module.exports = __webpack_public_path__ + "static/img/emt_example_payment6.8f89334.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/emt_example_payment6.jpg
// module id = tSLN
// module chunks = 0